// client/requestHandlers/upgrade.ts
import { map } from "rxjs/operators";
import { constructValue, fromNetwork } from "../../entities/adornisEntity";
import "../../metaDataStore";
import "../../protocol";
import "../../requestHandler";
import { upgradeAtDepth } from "../../utils/helpers";
var UpgradeHandler = class {
  constructor(upstream) {
    this.upstream = upstream;
    this.destroyed = false;
  }
  subscription(op, payload) {
    return this.upstream.subscription(op, payload).pipe(map((packed) => this.upgrade(op, packed)));
  }
  query(op, payload) {
    return this.upstream.query(op, payload).then((packed) => this.upgrade(op, packed));
  }
  mutation(op, payload) {
    return this.upstream.mutation(op, payload).then((packed) => this.upgrade(op, packed));
  }
  stop(payload) {
    this.upstream.stop(payload);
  }
  destroy() {
    if (this.destroyed)
      throw new Error("Destroying already destroyed UpgradeHandler!");
    this.destroyed = true;
    this.upstream.destroy();
  }
  upgrade(op, value) {
    if (op.arrayDepth()) {
      upgradeAtDepth(op, value, true);
      return value;
    }
    if (value && typeof value === "object")
      value[fromNetwork] = true;
    const upgraded = constructValue(value, op);
    return upgraded;
  }
};
export {
  UpgradeHandler
};
